var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.areaDeviceData.length > 0
      ? _c(
          "div",
          { staticClass: "tree-box-filter forbit-cancel-tree" },
          [
            _c("Input", {
              attrs: {
                clearable: "",
                type: "text",
                size: "large",
                maxlength: "50",
                placeholder:
                  _vm.currentStep === 0
                    ? _vm.$t("updateNewSip.filter1")
                    : _vm.$t("updateNewSip.filter2"),
              },
              model: {
                value: _vm.filterText,
                callback: function ($$v) {
                  _vm.filterText = $$v
                },
                expression: "filterText",
              },
            }),
            _c("Button", {
              attrs: { type: "primary", size: "large", icon: "ios-search" },
              on: { click: _vm.filterTree },
            }),
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      { staticClass: "tree-box" },
      [
        _c("el-tree", {
          ref: "tree",
          staticClass: "demo-tree-render",
          attrs: {
            size: "large",
            "empty-text":
              _vm.filterText.length > 0 ? _vm.$t("updateNewSip.noDataTip") : "",
            data: _vm.treeData,
            props: _vm.props,
            indent: 25,
            "node-key": "$treeNodeId",
            "highlight-current": true,
            "render-content": _vm.renderContent,
            "filter-node-method": _vm.filterNode,
            "current-node-key": _vm.currentChosenNode,
            "default-expanded-keys": [_vm.currentChosenNode],
          },
          on: { "node-click": _vm.selectTree },
        }),
        _vm.areaDeviceData.length === 0
          ? _c("div", { staticClass: "no-area" }, [
              _c("span"),
              _c("h4", [_vm._v(_vm._s(_vm.$t("deviceSip.noArea")))]),
            ])
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }